// extracted by mini-css-extract-plugin
export default {"body":"Admin_body__2sKec","column":"Admin_column__IZLRk","left":"Admin_left__iGjaE","right":"Admin_right__5SA-5","section":"Admin_section__JyTIB"};